<template>
  <div class="section-container" :class="{ 'with-hover-effect': enableHoverEffect }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SectionContainer',
  props: {
    enableHoverEffect: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.section-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 25px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.section-container.with-hover-effect:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
  background-color: #fafbff;
}

.section-container .card {
  margin: 0;
}

@media (max-width: 768px) {
  .section-container {
    padding: 20px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionContainer.vue